var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#B6BEC5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74609 0C3.85487 0 3.9592 0.0460936 4.03612 0.128141C4.11304 0.210188 4.15625 0.321468 4.15625 0.4375V0.875H10.7188V0.4375C10.7188 0.321468 10.762 0.210188 10.8389 0.128141C10.9158 0.0460936 11.0201 0 11.1289 0C11.2377 0 11.342 0.0460936 11.4189 0.128141C11.4959 0.210188 11.5391 0.321468 11.5391 0.4375V0.875H12.3594C12.7945 0.875 13.2118 1.05937 13.5195 1.38756C13.8271 1.71575 14 2.16087 14 2.625V12.25C14 12.7141 13.8271 13.1592 13.5195 13.4874C13.2118 13.8156 12.7945 14 12.3594 14H2.51562C2.0805 14 1.6632 13.8156 1.35553 13.4874C1.04785 13.1592 0.875 12.7141 0.875 12.25V4.375H14V3.5H0.875V2.625C0.875 2.16087 1.04785 1.71575 1.35553 1.38756C1.6632 1.05937 2.0805 0.875 2.51562 0.875H3.33594V0.4375C3.33594 0.321468 3.37915 0.210188 3.45607 0.128141C3.53299 0.0460936 3.63731 0 3.74609 0V0Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.d45df59a.svg";
export { ForwardRef as ReactComponent };